import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hasPromotion',
    pure: false
})
export class PipeHasPromotion implements PipeTransform {
    transform(unit: any): any {
        let old = unit?.amountOld? parseFloat(unit?.amountOld) : 0;
        let actual = unit?.amount? parseFloat(unit?.amount) : 0;
        return old > actual;
    }
}